import React from 'react';
import { Button, Input, Row, Col } from 'antd';
import { isMobile } from "react-device-detect";
const { TextArea } = Input;

const InputBox = ({ text, handleInput, onMessageSend, setText }) => {
    return (
        <Row className={isMobile ? 'input-box-body-mobile' : 'input-box-body-desktop'}>
            <Col span={19} className={isMobile ? 'input-field-container-mobile' : 'input-field-container-desktop'}>
                <TextArea 
                    className={isMobile ? 'input-field-mobile' : 'input-field-desktop'}
                    placeholder="Start typing..."
                    rows={2}
                    maxLength='800'
                    autoSize={{ minRows: 1, maxRows: 2 }}
                    onChange={handleInput}	
                    onKeyDown={(e) => {
                        if(e.key === 'Enter') {
                            if(text === '') {
                                e.preventDefault();
                                return;
                            }
                            onMessageSend(text);
                            setText('');
                           e.preventDefault();
                            return; 
                        }
                        if(e.key !== 'Enter') return;
                        if(text === '') return;
                        onMessageSend(text);
                        setText('');
                    }}
                    value={text}
                />
            </Col>
            <Col span={4}>
                <Button 
                    style={{ borderRadius: 4 }}
                    className={text !== '' ? 'primary-color' : ''}
                    disabled={text === ''}
                    type={isMobile ? 'text' : 'default'}
                    onClick={() => {
                        onMessageSend(text);
                        setText('');
                    }}
                >
                    Send
                </Button>
            </Col>
        </Row>
    );
}

export default InputBox;